import React from 'react';
import PropTypes from 'prop-types';
import NewspaperIcon from 'mdi-react/NewspaperIcon';
import ShapeOutlineIcon from 'mdi-react/ShapeOutlineIcon';
import ViewAgendaIcon from 'mdi-react/ViewAgendaIcon';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import SendCircleOutlineIcon from 'mdi-react/SendCircleOutlineIcon';
import CalendarClockIcon from 'mdi-react/CalendarClockIcon';
import ShieldAccountOutlineIcon from 'mdi-react/ShieldAccountOutlineIcon';
import PinOutlineIcon from 'mdi-react/PinOutlineIcon';
import BellRingOutlineIcon from 'mdi-react/BellRingOutlineIcon';
import HeartOutlineIcon from 'mdi-react/HeartOutlineIcon';
import LinkVariantIcon from 'mdi-react/LinkVariantIcon';
import { partial } from '../../../util/translation/translation';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';

/**
 * News in two steps: write the article (its type and the content blocks,
 * with the app preview beside), then publish it and reach the fans.
 */
const NewsShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  return (
    <FeatureShowcase
      storageKey="newsShowcaseHidden"
      icon={NewspaperIcon}
      title={s('newsInfoTitle')}
      subtitle={s('newsShowcaseSubtitle')}
      showLabel={s('newsShowcaseShow')}
      uses={[
        {
          key: 'write',
          step: s('showcaseStep', { step: 1 }),
          icon: NewspaperIcon,
          label: s('newsWriteLabel'),
          text: s('newsWriteText'),
          cards: [
            {
              key: 'types',
              icon: ShapeOutlineIcon,
              title: s('newsCardTypes'),
              text: s('newsCardTypesText'),
            },
            {
              key: 'blocks',
              icon: ViewAgendaIcon,
              title: s('newsCardBlocks'),
              text: s('newsCardBlocksText'),
            },
            {
              key: 'preview',
              icon: CellphoneIcon,
              title: s('newsCardPreview'),
              text: s('newsCardPreviewText'),
            },
          ],
        },
        {
          key: 'publish',
          step: s('showcaseStep', { step: 2 }),
          icon: SendCircleOutlineIcon,
          label: s('newsPublishLabel'),
          text: s('newsPublishText'),
          items: [
            {
              key: 'schedule',
              icon: CalendarClockIcon,
              label: s('newsItemSchedule'),
            },
            {
              key: 'access',
              icon: ShieldAccountOutlineIcon,
              label: s('newsItemAccess'),
            },
            { key: 'pin', icon: PinOutlineIcon, label: s('newsItemPin') },
            {
              key: 'push',
              icon: BellRingOutlineIcon,
              label: s('newsItemPush'),
            },
            {
              key: 'engage',
              icon: HeartOutlineIcon,
              label: s('newsItemEngage'),
            },
            { key: 'share', icon: LinkVariantIcon, label: s('newsItemShare') },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

NewsShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

NewsShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default NewsShowcase;
